import { render, staticRenderFns } from "./ModalNewBranch.vue?vue&type=template&id=1c70bb7e&"
import script from "./ModalNewBranch.vue?vue&type=script&lang=js&"
export * from "./ModalNewBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports